export default __webpack_public_path__ + "static/media/feature-race-texture.21fa2281.png";